import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, maybe } from "@saleor/misc";
import {
  SellerFilterKeys,
  SellerListFilterOpts
} from "@saleor/seller/components/SellerListPage/filters";
import { BrandInput, SmopStatusEnum } from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  SellerListUrlFilters,
  SellerListUrlFiltersEnum,
  SellerListUrlQueryParams
} from "../../urls";

export const SELLER_FILTERS_KEY = "sellerFilters";
export function getFilterOpts(
  params: SellerListUrlFilters
): SellerListFilterOpts {
  return {
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(() => findValueInEnum(params.status, SmopStatusEnum))
    }
  };
}

export function getFilterVariables(params: SellerListUrlFilters): BrandInput {
  return {
    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<SellerFilterKeys>
): SellerListUrlFilters {
  const { name } = filter;

  switch (name) {
    case SellerFilterKeys.status:
      return getSingleEnumValueQueryParam(
        filter,
        SellerListUrlFiltersEnum.status,
        SmopStatusEnum
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<SellerListUrlFilters>(SELLER_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  SellerListUrlQueryParams,
  SellerListUrlFilters
>(SellerListUrlFiltersEnum);
